import { FC, useCallback, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import ErrorBoundaryMessage from '../../app/components/error-handling/ErrorBoundaryMessage';
import AppSpinner from '../../common/components/AppSpinner';
import EmptyPageAvatar from '../../common/components/EmptyPageAvatar';
import GeneralErrorPage from '../../common/components/GeneralErrorPage';
import { useGradualUpdate } from '../../new-scan/actions/scan-actions';
import { loadIrrelevantApps } from '../actions/irrelevant-apps-actions';
import IrrelevantAppDialog from '../components/RelevantAppModal';
import IrrelevantAppsTable from '../components/IrrelevantAppsTable';
import { IrrelevantAppsStore } from '../stores/irrelevant-apps-store';
import ReasonFiltersStore from '../stores/reason-filters-store';

const IrrelevantAppsContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const {
    irrelevantApps,
    generalError,
    isLoading,
    selectedReleventApp,
    relevntModal,
    isRemoveIrrelevantAppLoading,
  } = useSnapshot(IrrelevantAppsStore);

  const { isLoadingFilters } = useSnapshot(ReasonFiltersStore);

  useEffect(() => {
    loadIrrelevantApps();
  }, []);

  useGradualUpdate(
    useCallback(() => {
      loadIrrelevantApps();
    }, []),
  );

  if (generalError) {
    return (
      <GeneralErrorPage
        showOxIcon
        errorTitle='Oops, an error has occurred :('
        errorMsg={<ErrorBoundaryMessage />}
      />
    );
  } else if (isLoading) {
    return <AppSpinner text='Fetching Irrelevant Apps' />;
  } else if (!generalError && irrelevantApps.result.length === 0) {
    return (
      <EmptyPageAvatar text='No irrelevant apps were discovered during the scan. There were also no irrelevant apps set manually.' />
    );
  }

  return (
    <>
      <IrrelevantAppDialog
        relevntModal={relevntModal}
        selectedApp={selectedReleventApp}
        isRemoveIrrelevantAppLoading={isRemoveIrrelevantAppLoading}
      />
      <IrrelevantAppsTable
        filters={irrelevantApps.filters}
        irrelevantApps={irrelevantApps.result}
        isLoadingFilters={isLoadingFilters}
      />
    </>
  );
};

export default IrrelevantAppsContainer;
